// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M7.7,5c0.6,0,1.2,0.2,1.7,0.5c1.1,0.6,1.7,1.8,1.6,3c-0.1,0.9,0.2,1.8,0.8,2.4l6.3,6.3c0.4,0.3,0.5,0.9,0.2,1.3
		c-0.2,0.3-0.5,0.5-0.8,0.5c-0.3,0-0.5-0.1-0.7-0.3l-6.4-6.4c-0.6-0.5-1.3-0.8-2.1-0.8H7.7c-0.8,0-1.7-0.4-2.2-1h2.7V6.4H5.1
		c0.3-0.4,0.6-0.8,1.1-1C6.7,5.1,7.2,5,7.7,5 M7.7,4C7,4,6.3,4.2,5.7,4.5C4.6,5.1,3.8,6.2,3.6,7.4h3.6v2.1H3.7
		c0.2,0.7,0.6,1.3,1,1.8c0.8,0.8,1.9,1.2,3,1.2h0.6c0.5,0,1,0.2,1.4,0.5l6.4,6.4c0.4,0.4,0.9,0.6,1.4,0.6c0.7,0,1.3-0.3,1.6-0.9
		c0.6-0.8,0.4-1.9-0.3-2.6l-6.3-6.3c-0.4-0.4-0.6-1-0.5-1.6c0.1-1.6-0.7-3.1-2-4C9.3,4.2,8.5,4,7.7,4z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-tool-C3q_ZzJH.js.map
